
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./frontend/app.tsx";
              export default OriginalModule.default;
              export * from "./frontend/app.tsx";